/**
 * useEmbedResize Hook
 * When rendered inside an iframe, reports document height changes to the parent
 * window via postMessage so the host page can auto-size the iframe.
 */

import { useEffect } from 'react';
import { isEmbedded } from '../utils/authHelper';

export function useEmbedResize(): void {
  useEffect(() => {
    if (!isEmbedded()) return;

    const reportHeight = (): void => {
      const height = document.documentElement.scrollHeight;
      window.parent.postMessage({ type: 'cla-quiz-resize', height }, '*');
    };

    reportHeight();

    const observer = new ResizeObserver(reportHeight);
    observer.observe(document.documentElement);

    return () => observer.disconnect();
  }, []);
}

/**
 * Notifies the host page (if embedded) that the quiz was submitted.
 */
export function postEmbedComplete(assessmentId: number | string): void {
  if (!isEmbedded()) return;
  window.parent.postMessage({ type: 'cla-quiz-complete', assessmentId }, '*');
}
